<template>
  <div :class="$style.toggleItem">
    <div
      :class="[$style.toggleItemTitleBlock, isTabletLandscapeUp ? $style.defaultText : $style.smallText]"
      @click="toggleDetails"
    >
      <p :class="$style.toggleItemTitle">
        {{ title }}
      </p>
      <p :class="$style.toggleItemIcon">
        <IconArrowDown
          width="27"
        />
      </p>
    </div>
    <div
      v-if="showDetails"
      :class="[$style.toggleItemContentBlock, isTabletLandscapeUp ? $style.defaultText : $style.smallText]"
    >
      <p v-html="content" />
    </div>
  </div>
</template>

<script>
import IconArrowDown from '@/images/icons/arrow-down.svg';
import { mapGetters } from 'vuex';

export default {
  components: {
    IconArrowDown,
  },

  props: {
    title: String,
    content: String,
  },

  data() {
    return {
      showDetails: false,
    };
  },

  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
  },

  computed: {
    ...mapGetters('ui', [
      'isTabletLandscapeUp',
    ]),
  },
};

</script>

<style lang="scss" module>

.defaultText {
  font-size: 20px;
}

.smallText {
  font-size: 14px;
}

.toggleItem {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 1px;
}

.toggleItemTitleBlock {
  cursor: pointer;
  display: flex;
  background-color: rgba(197, 197, 197, 0.629359);
  justify-content: space-between;
}

.toggleItemTitle {
  flex: 1;
  text-align: left;
  padding: 5px;
  padding-left: 30px;
}

.toggleItemIcon {
  flex: 0;
  text-align: right;
  padding-right: 15px;
}

.toggleItemContentBlock {
  width: 100%;
  text-align: left;
  background-color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  padding: 30px;
}

</style>
